// components/DnDMonsterStats.tsx

import React from "react";
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/react";
import Image from "next/image";
import { ChevronDown, ChevronUp } from "components/atoms/Icon";
import { DnD5eMonsterDTO } from "types";
import * as Styled from "./MonsterStats.styled";
interface MonsterStatsProps {
  stats: DnD5eMonsterDTO;
}
const MonsterStats: React.FC<MonsterStatsProps> = ({
  stats
}) => {
  return <Styled.Container data-sentry-element="unknown" data-sentry-component="MonsterStats" data-sentry-source-file="index.tsx">
            <Styled.DisclosureContainer data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                <Disclosure data-sentry-element="Disclosure" data-sentry-source-file="index.tsx">
                    {({
          open
        }) => <>
                            <DisclosureButton className="disclosure-button">
                                General Info
                                <Styled.Icon>
                                    <Image height={24} width={24} src={open ? ChevronUp : ChevronDown} alt="Toggle Accordion" />
                                </Styled.Icon>
                            </DisclosureButton>
                            <DisclosurePanel className="disclosure-panel">
                                <Styled.StatItem>
                                    <Styled.StatLabel>Name:</Styled.StatLabel>
                                    <Styled.StatValue>
                                        {stats.name}
                                    </Styled.StatValue>
                                </Styled.StatItem>
                                <Styled.StatItem>
                                    <Styled.StatLabel>
                                        Monster:
                                    </Styled.StatLabel>
                                    <Styled.StatValue>
                                        {stats.monsterType}
                                    </Styled.StatValue>
                                </Styled.StatItem>
                                <Styled.StatItem>
                                    <Styled.StatLabel>
                                        CR Level:
                                    </Styled.StatLabel>
                                    <Styled.StatValue>
                                        {stats.crLevel}
                                    </Styled.StatValue>
                                </Styled.StatItem>
                                <Styled.StatItem>
                                    <Styled.StatLabel>
                                        Hit Points:
                                    </Styled.StatLabel>
                                    <Styled.StatValue>
                                        {stats.hitPoints}
                                    </Styled.StatValue>
                                </Styled.StatItem>
                                <Styled.StatItem>
                                    <Styled.StatLabel>
                                        Armor Class:
                                    </Styled.StatLabel>
                                    <Styled.StatValue>
                                        {stats.armorClass}
                                    </Styled.StatValue>
                                </Styled.StatItem>
                                <Styled.StatItem>
                                    <Styled.StatLabel>Speed:</Styled.StatLabel>
                                    <Styled.StatValue>
                                        {stats.speed}
                                    </Styled.StatValue>
                                </Styled.StatItem>
                                <Styled.StatItem>
                                    <Styled.StatLabel>Size:</Styled.StatLabel>
                                    <Styled.StatValue>
                                        {stats.size}
                                    </Styled.StatValue>
                                </Styled.StatItem>
                                <Styled.StatItem>
                                    <Styled.StatLabel>
                                        Environment:
                                    </Styled.StatLabel>
                                    <Styled.StatValue>
                                        {stats.environment}
                                    </Styled.StatValue>
                                </Styled.StatItem>
                                <Styled.StatItem>
                                    <Styled.StatLabel>
                                        Alignment:
                                    </Styled.StatLabel>
                                    <Styled.StatValue>
                                        {stats.alignment}
                                    </Styled.StatValue>
                                </Styled.StatItem>
                                <Styled.StatItem>
                                    <Styled.StatLabel>
                                        Languages:
                                    </Styled.StatLabel>
                                    <Styled.StatValue>
                                        {stats.languages.join(", ")}
                                    </Styled.StatValue>
                                </Styled.StatItem>
                            </DisclosurePanel>
                        </>}
                </Disclosure>

                <Disclosure data-sentry-element="Disclosure" data-sentry-source-file="index.tsx">
                    {({
          open
        }) => <>
                            <DisclosureButton className="disclosure-button">
                                Attributes
                                <Styled.Icon>
                                    <Image height={24} width={24} src={open ? ChevronUp : ChevronDown} alt="Toggle Accordion" />
                                </Styled.Icon>
                            </DisclosureButton>
                            <Disclosure.Panel className="disclosure-panel">
                                <Styled.GridContainer>
                                    {stats.attributes.map(attr => <Styled.StatItem key={attr.name}>
                                            <Styled.StatLabel>
                                                {attr.name}:
                                            </Styled.StatLabel>
                                            <Styled.StatValue>
                                                {attr.value} ({attr.modifier})
                                            </Styled.StatValue>
                                        </Styled.StatItem>)}
                                </Styled.GridContainer>
                            </Disclosure.Panel>
                        </>}
                </Disclosure>

                <Disclosure data-sentry-element="Disclosure" data-sentry-source-file="index.tsx">
                    {({
          open
        }) => <>
                            <DisclosureButton className="disclosure-button">
                                Skills
                                <Styled.Icon>
                                    <Image height={24} width={24} src={open ? ChevronUp : ChevronDown} alt="Toggle Accordion" />
                                </Styled.Icon>
                            </DisclosureButton>
                            <DisclosurePanel className="disclosure-panel">
                                <Styled.GridContainer>
                                    {stats.skills.map(skill => <Styled.StatItem key={skill.name}>
                                            <Styled.StatLabel>
                                                {skill.name}:
                                            </Styled.StatLabel>
                                            <Styled.StatValue>
                                                {skill.bonus}
                                            </Styled.StatValue>
                                        </Styled.StatItem>)}
                                </Styled.GridContainer>
                            </DisclosurePanel>
                        </>}
                </Disclosure>

                <Disclosure data-sentry-element="Disclosure" data-sentry-source-file="index.tsx">
                    {({
          open
        }) => <>
                            <DisclosureButton className="disclosure-button">
                                Spells
                                <Styled.Icon>
                                    <Image height={24} width={24} src={open ? ChevronUp : ChevronDown} alt="Toggle Accordion" />
                                </Styled.Icon>
                            </DisclosureButton>
                            <DisclosurePanel className="disclosure-panel">
                                {stats.spells.map(spell => <Styled.StatItem key={spell.name}>
                                        <Styled.StatLabel>
                                            {spell.name} (Level {spell.level},{" "}
                                            {spell.school}):
                                        </Styled.StatLabel>
                                        <Styled.StatValue>
                                            {spell.description}
                                        </Styled.StatValue>
                                    </Styled.StatItem>)}
                            </DisclosurePanel>
                        </>}
                </Disclosure>

                <Disclosure data-sentry-element="Disclosure" data-sentry-source-file="index.tsx">
                    {({
          open
        }) => <>
                            <DisclosureButton className="disclosure-button">
                                Saving Throws
                                <Styled.Icon>
                                    <Image height={24} width={24} src={open ? ChevronUp : ChevronDown} alt="Toggle Accordion" />
                                </Styled.Icon>
                            </DisclosureButton>
                            <DisclosurePanel className="disclosure-panel">
                                <Styled.GridContainer>
                                    {stats.savingThrows.map(savingThrow => <Styled.StatItem key={savingThrow.attribute.name}>
                                            <Styled.StatLabel>
                                                {savingThrow.attribute.name}:
                                            </Styled.StatLabel>
                                            <Styled.StatValue>
                                                {savingThrow.bonus}
                                            </Styled.StatValue>
                                        </Styled.StatItem>)}
                                </Styled.GridContainer>
                            </DisclosurePanel>
                        </>}
                </Disclosure>

                <Disclosure data-sentry-element="Disclosure" data-sentry-source-file="index.tsx">
                    {({
          open
        }) => <>
                            <DisclosureButton className="disclosure-button">
                                Legendary Actions
                                <Styled.Icon>
                                    <Image height={24} width={24} src={open ? ChevronUp : ChevronDown} alt="Toggle Accordion" />
                                </Styled.Icon>
                            </DisclosureButton>
                            <DisclosurePanel className="disclosure-panel">
                                {stats.legendaryActions.map(action => <Styled.StatItem key={action.name}>
                                        <Styled.StatLabel>
                                            {action.name}:
                                        </Styled.StatLabel>
                                        <Styled.StatValue>
                                            {action.description} (Cost:{" "}
                                            {action.cost})
                                        </Styled.StatValue>
                                    </Styled.StatItem>)}
                            </DisclosurePanel>
                        </>}
                </Disclosure>

                <Disclosure data-sentry-element="Disclosure" data-sentry-source-file="index.tsx">
                    {({
          open
        }) => <>
                            <DisclosureButton className="disclosure-button">
                                Actions
                                <Styled.Icon>
                                    <Image height={24} width={24} src={open ? ChevronUp : ChevronDown} alt="Toggle Accordion" />
                                </Styled.Icon>
                            </DisclosureButton>
                            <DisclosurePanel className="disclosure-panel">
                                {stats.actions.map(action => <Styled.StatItem key={action.name}>
                                        <Styled.StatLabel>
                                            {action.name}:
                                        </Styled.StatLabel>
                                        <Styled.StatValue>
                                            {action.description}
                                        </Styled.StatValue>
                                    </Styled.StatItem>)}
                            </DisclosurePanel>
                        </>}
                </Disclosure>

                <Disclosure data-sentry-element="Disclosure" data-sentry-source-file="index.tsx">
                    {({
          open
        }) => <>
                            <DisclosureButton className="disclosure-button">
                                Reactions
                                <Styled.Icon>
                                    <Image height={24} width={24} src={open ? ChevronUp : ChevronDown} alt="Toggle Accordion" />
                                </Styled.Icon>
                            </DisclosureButton>
                            <DisclosurePanel className="disclosure-panel">
                                {stats.reactions.map(reaction => <Styled.StatItem key={reaction.name}>
                                        <Styled.StatLabel>
                                            {reaction.name}:
                                        </Styled.StatLabel>
                                        <Styled.StatValue>
                                            {reaction.description}
                                        </Styled.StatValue>
                                    </Styled.StatItem>)}
                            </DisclosurePanel>
                        </>}
                </Disclosure>

                <Disclosure data-sentry-element="Disclosure" data-sentry-source-file="index.tsx">
                    {({
          open
        }) => <>
                            <DisclosureButton className="disclosure-button">
                                Equipment
                                <Styled.Icon>
                                    <Image height={24} width={24} src={open ? ChevronUp : ChevronDown} alt="Toggle Accordion" />
                                </Styled.Icon>
                            </DisclosureButton>
                            <DisclosurePanel className="disclosure-panel">
                                {stats.equipment.map(item => <Styled.StatItem key={item.name}>
                                        <Styled.StatLabel>
                                            {item.name} ({item.type}):
                                        </Styled.StatLabel>
                                        <Styled.StatValue>
                                            {item.description} (Value:{" "}
                                            {item.value})
                                        </Styled.StatValue>
                                    </Styled.StatItem>)}
                            </DisclosurePanel>
                        </>}
                </Disclosure>
            </Styled.DisclosureContainer>
        </Styled.Container>;
};
export default MonsterStats;